import { Component, OnInit } from '@angular/core';
import { AgentFamilyHandlerComponent } from './agent-family.handler';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-family',
  templateUrl: './agent-family.component.html',
  styleUrls: ['./agent-family.component.scss'],
})
export class AgentFamilyComponent extends AgentFamilyHandlerComponent {
  constructor(agentService: AgentService) {
    super(agentService);
  }
}
